import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Icon, _Icon2;
var _excluded = ["sx"],
  _excluded2 = ["buttonText", "icon", "onClick", "size", "triggerType", "variant"];
/* eslint-disable max-lines */
import React, { useEffect, useState, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Stack from '@mui/material/Stack';
import { Icon } from '../Icon';
import { Button } from '../Button';
import { PopoverHeader } from '../PopoverHeader';
import Box from '@mui/material/Box';
import { SHADOWS } from '@im/im-theme/constants';
import { WHITE } from '../common';
import { getPlacement } from '../utils/navigation-utils';
import { PopoverFooter } from '../PopoverFooter';
import { PopoverFilter } from '../PopoverFilter';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var POPOVER_BORDER_RADIUS = '8px';
export function Popover(props) {
  var _controlledAnchorEl$c;
  var _props$actions = props.actions,
    actions = _props$actions === void 0 ? true : _props$actions,
    controlledAnchorEl = props.anchorEl,
    _props$buttonXClose = props.buttonXClose,
    buttonXClose = _props$buttonXClose === void 0 ? true : _props$buttonXClose,
    _children = props.children,
    featuredIcon = props.featuredIcon,
    featuredIconColor = props.featuredIconColor,
    featuredIconSize = props.featuredIconSize,
    featuredIconTheme = props.featuredIconTheme,
    _props$footerDivider = props.footerDivider,
    footerDivider = _props$footerDivider === void 0 ? false : _props$footerDivider,
    _props$footerType = props.footerType,
    footerType = _props$footerType === void 0 ? 'horizontal-right-aligned' : _props$footerType,
    _props$headerDivider = props.headerDivider,
    headerDivider = _props$headerDivider === void 0 ? false : _props$headerDivider,
    headerText = props.headerText,
    _props$hideHeader = props.hideHeader,
    hideHeader = _props$hideHeader === void 0 ? false : _props$hideHeader,
    _onClose = props.onClose,
    controlledOpen = props.open,
    popoverFilterBody = props.popoverFilterBody,
    popoverFilterProps = props.popoverFilterProps,
    popoverTriggerProps = props.popoverTriggerProps,
    popperProps = props.popperProps,
    primaryButtonProps = props.primaryButtonProps,
    secondaryButtonProps = props.secondaryButtonProps,
    _props$showFeaturedIc = props.showFeaturedIcon,
    showFeaturedIcon = _props$showFeaturedIc === void 0 ? true : _props$showFeaturedIc,
    supportingText = props.supportingText,
    tertiaryButtonProps = props.tertiaryButtonProps,
    _props$tipPlacement = props.tipPlacement,
    tipPlacement = _props$tipPlacement === void 0 ? 'Top Center' : _props$tipPlacement,
    width = props.width;
  var _ref = popperProps != null ? popperProps : {},
    popperSx = _ref.sx,
    otherPopperProps = _objectWithoutProperties(_ref, _excluded);
  var buttonVariant = popoverTriggerProps.triggerType === 'Icon' ? 'link-gray' : 'secondary-gray';
  buttonVariant = popoverTriggerProps.triggerType === 'Link' ? 'link' : buttonVariant;
  var defaultButtonSize = popoverTriggerProps.triggerType === 'Icon' ? 'small' : 'medium';
  var buttonText = popoverTriggerProps.buttonText,
    _popoverTriggerProps$ = popoverTriggerProps.icon,
    icon = _popoverTriggerProps$ === void 0 ? 'ChevronDown' : _popoverTriggerProps$,
    onClick = popoverTriggerProps.onClick,
    size = popoverTriggerProps.size,
    _popoverTriggerProps$2 = popoverTriggerProps.triggerType,
    triggerType = _popoverTriggerProps$2 === void 0 ? 'Button' : _popoverTriggerProps$2,
    _popoverTriggerProps$3 = popoverTriggerProps.variant,
    variant = _popoverTriggerProps$3 === void 0 ? buttonVariant : _popoverTriggerProps$3,
    otherPopoverTriggerProps = _objectWithoutProperties(popoverTriggerProps, _excluded2);
  var anchorEl = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var contentRef = useRef(null);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    arrowRef = _useState4[0],
    setArrowRef = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    contentScrollbar = _useState6[0],
    setContentScrollbar = _useState6[1];
  var theme = useTheme();
  var popoverOpen = controlledOpen !== undefined ? controlledOpen : open;
  useEffect(function () {
    var handleResize = function handleResize() {
      var _contentRef$current;
      var _ref2 = (_contentRef$current = contentRef.current) != null ? _contentRef$current : {},
        _ref2$offsetWidth = _ref2.offsetWidth,
        offsetWidth = _ref2$offsetWidth === void 0 ? 0 : _ref2$offsetWidth,
        _ref2$scrollWidth = _ref2.scrollWidth,
        scrollWidth = _ref2$scrollWidth === void 0 ? 0 : _ref2$scrollWidth;
      setContentScrollbar(offsetWidth !== scrollWidth);
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var popoverContentPaddingRight = contentScrollbar ? 12 : 16;
  var handlePopoverOpen = function handlePopoverOpen() {
    setOpen(true);
    onClick && onClick(true);
  };
  var handlePopoverClose = function handlePopoverClose(event) {
    var _anchorEl$current;
    (_anchorEl$current = anchorEl.current) == null ? void 0 : _anchorEl$current.focus();
    setOpen(false);
    onClick && onClick(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [triggerType !== 'Custom' && /*#__PURE__*/_jsxs(Button, _extends({
      endIcon: triggerType === 'Button' && (!open ? _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        iconId: "ChevronDown",
        size: 20
      })) : _Icon2 || (_Icon2 = /*#__PURE__*/_jsx(Icon, {
        iconId: "ChevronUp",
        size: 20
      }))),
      onClick: handlePopoverOpen,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Escape') {
          handlePopoverClose(e);
        }
      },
      ref: anchorEl,
      size: size ? size : defaultButtonSize,
      sx: {
        background: triggerType === 'Button' && open ? theme.palette.gray[100] : 'inherit',
        color: triggerType === 'Link' && open ? theme.palette.primary[800] : 'default'
      },
      variant: variant
    }, otherPopoverTriggerProps, {
      children: [triggerType !== 'Icon' ? buttonText : null, triggerType === 'Icon' ? /*#__PURE__*/_jsx(Icon, {
        color: open ? theme.palette.gray[400] : theme.palette.gray[500],
        iconId: open && icon === 'ChevronDown' ? 'ChevronUp' : icon,
        size: 20
      }) : null]
    })), /*#__PURE__*/_jsx(Popper, _extends({
      anchorEl: (_controlledAnchorEl$c = controlledAnchorEl == null ? void 0 : controlledAnchorEl.current) != null ? _controlledAnchorEl$c : anchorEl.current,
      disablePortal: true,
      modifiers: [{
        enabled: true,
        name: 'arrow',
        options: {
          element: arrowRef
        }
      }],
      open: popoverOpen,
      placement: getPlacement(tipPlacement),
      role: "popper",
      sx: _extends({
        '& .MuiPaper-root': {
          margin: 0,
          overflow: 'hidden',
          width: width !== undefined ? width : '320px'
        },
        '&:focus-visible .popper-arrow::before': {
          outline: "1px solid ".concat(theme.palette.common.black)
        },
        '&[data-popper-placement*="bottom"] .popper-arrow': {
          '&::before': {
            transformOrigin: '0 100%'
          },
          left: 0,
          marginRight: '-4px',
          marginTop: '-11.36px',
          top: 0
        },
        '&[data-popper-placement*="left"] .popper-arrow': {
          '&::before': {
            transformOrigin: '0 0'
          },
          marginRight: '-11.36px',
          marginTop: '-18px',
          right: 0
        },
        '&[data-popper-placement*="right"] .popper-arrow': {
          '&::before': {
            transformOrigin: '100% 100%'
          },
          left: 0,
          marginLeft: '-11.36px',
          marginTop: '-10px'
        },
        '&[data-popper-placement*="top"] .popper-arrow': {
          '&::before': {
            transformOrigin: '100% 0'
          },
          bottom: 0,
          left: '4px !important',
          marginBottom: '-11.36px',
          marginLeft: '-4px'
        },
        '&[data-popper-placement="left"], &[data-popper-placement="right"]': {
          margin: '16px !important'
        },
        // eslint-disable-next-line sort-keys
        '&[data-popper-placement="left"]': {
          marginRight: triggerType === 'Custom' ? 'default !important' : getMargin(triggerType)
        },
        '&[data-popper-placement="right"]': {
          marginLeft: getMargin(triggerType)
        },
        borderRadius: POPOVER_BORDER_RADIUS,
        boxShadow: theme.shadows[SHADOWS.lg],
        margin: '16px 0px !important',
        zIndex: 2000
      }, popperSx),
      tabIndex: 0,
      transition: true
    }, otherPopperProps, {
      "data-element": "Popper",
      "data-source-file": "Popover.tsx",
      children: function children(_ref3) {
        var TransitionProps = _ref3.TransitionProps;
        return /*#__PURE__*/_jsx(Fade, _extends({}, TransitionProps, {
          style: {
            transformOrigin: 'top-center'
          },
          children: /*#__PURE__*/_jsxs(Paper, {
            sx: {
              border: "1px solid ".concat(theme.palette.gray[200]),
              borderRadius: POPOVER_BORDER_RADIUS
            },
            children: [tipPlacement !== 'None' ? /*#__PURE__*/_jsx(Box, {
              className: "popper-arrow",
              component: "span",
              ref: setArrowRef,
              sx: {
                '&::before': {
                  backgroundColor: 'currentColor',
                  border: "1px solid ".concat(theme.palette.gray[200]),
                  content: '""',
                  display: 'block',
                  height: '100%',
                  margin: 'auto',
                  transform: 'rotate(45deg)',
                  width: '100%'
                },
                boxSizing: 'border-box',
                color: WHITE,
                height: '11.36px',
                position: 'absolute',
                width: '14px'
              }
            }) : null, /*#__PURE__*/_jsx(ClickAwayListener, {
              onClickAway: function onClickAway(e) {
                handlePopoverClose(e);
                if (_onClose) _onClose('clickAway');
              },
              children: /*#__PURE__*/_jsxs(Stack, {
                marginBottom: !actions ? '16px' : 0,
                role: "Popover",
                spacing: 4,
                sx: {
                  backgroundColor: WHITE,
                  position: 'relative',
                  zIndex: 2000
                },
                children: [/*#__PURE__*/_jsx(PopoverHeader, {
                  buttonXClose: buttonXClose,
                  divider: headerDivider,
                  featuredIcon: featuredIcon,
                  featuredIconColor: featuredIconColor,
                  featuredIconSize: featuredIconSize,
                  featuredIconTheme: featuredIconTheme,
                  hidden: hideHeader,
                  onClose: function onClose(e) {
                    handlePopoverClose(e);
                    if (_onClose) _onClose('xCloseButton');
                  },
                  showFeaturedIcon: showFeaturedIcon,
                  supportingText: supportingText,
                  text: headerText
                }), popoverFilterProps && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(PopoverFilter, _extends({
                    hasPopoverFilterBody: !!popoverFilterBody
                  }, popoverFilterProps)), popoverFilterBody && /*#__PURE__*/_jsx(Box, {
                    sx: {
                      borderBottom: "1px solid ".concat(theme.palette.gray[200]),
                      marginTop: '0px!important',
                      padding: 4
                    },
                    children: popoverFilterBody
                  })]
                }), _children && /*#__PURE__*/_jsx(Box, {
                  ref: contentRef,
                  sx: {
                    marginBottom: 4,
                    overflowX: 'hidden',
                    padding: 0,
                    paddingBottom: footerType === 'hidden' ? 4 : 0,
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingTop: hideHeader ? 4 : 0
                  },
                  children: /*#__PURE__*/_jsx(Box, {
                    width: "calc(100% - ".concat(popoverContentPaddingRight),
                    children: _children
                  })
                }), actions && /*#__PURE__*/_jsx(PopoverFooter, _extends({
                  divider: footerDivider,
                  primaryButtonProps: _extends({}, primaryButtonProps, {
                    onClick: function onClick(e) {
                      handlePopoverClose(e);
                      if (_onClose) _onClose('primaryButton');
                      if (primaryButtonProps != null && primaryButtonProps.onClick) primaryButtonProps.onClick(e);
                    }
                  })
                }, tertiaryButtonProps && {
                  tertiaryButtonProps: _extends({}, tertiaryButtonProps, {
                    onClick: function onClick(e) {
                      handlePopoverClose(e);
                      if (_onClose) _onClose('tertiaryButton');
                      if (tertiaryButtonProps != null && tertiaryButtonProps.onClick) tertiaryButtonProps.onClick(e);
                    }
                  })
                }, secondaryButtonProps && {
                  secondaryButtonProps: _extends({}, secondaryButtonProps, {
                    onClick: function onClick(e) {
                      handlePopoverClose(e);
                      if (_onClose) _onClose('secondaryButton');
                      if (secondaryButtonProps != null && secondaryButtonProps.onClick) secondaryButtonProps.onClick(e);
                    }
                  })
                }, {
                  type: footerType
                }))]
              })
            })]
          })
        }));
      }
    }))]
  });
}
var getMargin = function getMargin(triggerType) {
  if (triggerType === 'Icon') {
    return '-18px !important';
  }
  if (triggerType === 'Link') {
    return '0px !important';
  }
  if (triggerType === 'Custom') {
    return '-12px !important';
  }
  return 'default !important';
};